export function RefreshIconButton({ onClick, disabled = false, className = '', title = '새로고침' }) {
  return (
    <button
      type="button"
      className={`shared-refresh-button ${className}`.trim()}
      onClick={onClick}
      disabled={disabled}
      title={title}
      aria-label={title}
    >
      <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
        <path d="M19.4 7.2A8 8 0 1 0 20 15h-2.1a6 6 0 1 1-.3-5.9L15 11.7h6V5.8l-1.6 1.4Z" />
      </svg>
    </button>
  );
}
